import { memo } from 'react';
import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const ButtonPrimaryLarge = ({
  id,
  title,
  preIcon,
  posIcon,
  disabled,
  style,
  onClick,
  type = 'button',
  loading = false,
  ...props
}) => {
  return (
    <button
      type={type}
      id={id}
      className={cn(
        'inline-flex justify-center items-center bg-primary-primary hover:bg-primary-primaryVarient1 disabled:bg-primary-primaryVarient2 disabled:text-white-medium',
        'h-[40px] py-[10px] px-[16px] gap-[8px] text-body-large font-semibold rounded-[8px]',
        posIcon || preIcon ? 'py-[8px]' : '',
        props.className
      )}
      disabled={disabled}
      style={{
        ...style,
        ...{
          paddingRight: `${preIcon ? '12px' : undefined}`,
          paddingLeft: `${posIcon ? '12px' : undefined}`,
        },
      }}
      onClick={onClick}
    >
      {posIcon && (
        <div
          className={cn(
            'w-[24px] h-[24px] flex content-center text-white-high disabled:text-white-medium',
            props.classNames?.posIcon
          )}
        >
          {posIcon}
        </div>
      )}
      <span className="truncate text-white-high disabled:text-white-medium">
        {title}
      </span>
      <Spin spinning={loading} size={24} />
      {preIcon && (
        <div
          className={cn(
            'w-[24px] h-[24px] flex content-center text-white-high disabled:text-white-medium',
            props.classNames?.preIcon
          )}
        >
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default memo(ButtonPrimaryLarge);
